// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"296":"privacy","327":"solo","328":"admin","443":"about","954":"hall-of-fame"}[chunkId] || chunkId) + "." + {"255":"c773ad0d","296":"7368d0bd","327":"ef77b5ac","328":"5cc45064","443":"d43d3f28","954":"e7b08094"}[chunkId] + ".css";
};